export default {
  topText: {
    id: 'product_page_carousel_sticker_top_text',
    defaultMessage: 'Professionally',
  },
  topTextLocal: {
    id: 'product_page_carousel_sticker_top_text_local',
    defaultMessage: 'Refurbished',
  },
  bottomText: {
    id: 'product_page_carousel_sticker_bottom_text',
    defaultMessage: 'refurbished',
  },
  bottomTextLocal: {
    id: 'product_page_carousel_sticker_bottom_text_local',
    defaultMessage: 'in the US',
  },
}
